import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../components/PageHeader";

const AboutPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const valuesValue = t("about.values", { returnObjects: true });
  const teamValue = t("about.teamMembers", { returnObjects: true });
  const values = Array.isArray(valuesValue) ? valuesValue : [];
  const team = Array.isArray(teamValue) ? teamValue : [];

  return (
    <>
      <style>{`
        .about-section { padding:80px 60px; }
        .about-grid { display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; }
        .about-img-wrap { position:relative; }
        .about-img-main { width:100%; border-radius:16px; height:500px; max-height:500px; aspect-ratio:4/5; object-fit:cover; box-shadow:0 20px 50px rgba(0,0,0,0.15); display:block; background:#e7decd; }
        .about-float-badge { position:absolute; bottom:-24px; inset-inline-end:-24px; background:linear-gradient(135deg,var(--gold),var(--gold-dark)); color:white; padding:24px 28px; border-radius:12px; text-align:center; box-shadow:0 10px 30px rgba(201,168,76,0.3); }
        .afb-num { font-family:var(--font-heading); font-size:40px; font-weight:700; }
        .afb-label { font-size:12px; letter-spacing:1.5px; opacity:0.9; }
        .values-grid { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-top:28px; }
        .value-card { background:white; padding:24px; border-radius:12px; border-inline-start:4px solid var(--gold); box-shadow:0 4px 16px rgba(0,0,0,0.06); }
        .team-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:24px; }
        .team-card { text-align:center; background:white; border-radius:14px; padding:32px 20px; box-shadow:0 4px 20px rgba(0,0,0,0.07); transition:all 0.3s; }
        .team-card:hover { transform:translateY(-6px); box-shadow:0 16px 40px rgba(0,0,0,0.12); }
        .team-avatar { width:80px; height:80px; border-radius:50%; margin:0 auto 16px; background:linear-gradient(135deg,var(--gold),var(--gold-dark)); display:flex; align-items:center; justify-content:center; font-family:var(--font-heading); font-size:32px; color:white; }
        .team-name { font-family:var(--font-heading); font-size:20px; margin-bottom:4px; color:var(--deep); }
        .team-role { font-size:13px; color:var(--gold); font-weight:600; letter-spacing:1px; }
        @media(max-width:768px){ .about-section{padding:50px 20px} .about-grid{grid-template-columns:1fr;gap:32px} .about-img-main{height:280px} .about-float-badge{inset-inline-end:0;bottom:-16px} .values-grid{grid-template-columns:1fr} .team-grid{grid-template-columns:1fr} }
      `}</style>

      <PageHeader
        tag={t("about.headerTag")}
        title={t("about.headerTitle")}
        subtitle={t("about.headerSub")}
      />

      <section className="about-section" style={{background:"var(--cream)"}}>
        <div className="about-grid">
          <div className="about-img-wrap">
            <img className="about-img-main" src="https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=800&q=80" alt="Anassik Travel" loading="lazy" />
            <div className="about-float-badge">
              <div className="afb-num">10+</div>
              <div className="afb-label">{t("about.trustLabel")}</div>
            </div>
          </div>
          <div>
            <span className="section-tag">{t("about.whoTag")}</span>
            <h2 className="section-title">{t("about.whoTitle")}</h2>
            <div className="gold-divider" />
            <p style={{color:"var(--text-muted)",fontSize:15,lineHeight:1.8,marginBottom:16}}>{t("about.p1")}</p>
            <p style={{color:"var(--text-muted)",fontSize:15,lineHeight:1.8}}>{t("about.p2")}</p>
            <div className="values-grid">
              {values.map((value) => (
                <div key={value.title} className="value-card">
                  <div style={{fontSize:22,marginBottom:8}}>{value.icon}</div>
                  <div style={{fontFamily:"var(--font-heading)",fontSize:16,fontWeight:700,marginBottom:4,color:"var(--deep)"}}>{value.title}</div>
                  <div style={{fontSize:13,color:"var(--text-muted)"}}>{value.text}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="about-section" style={{background:"white"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <span className="section-tag">{t("about.teamTag")}</span>
          <h2 className="section-title">{t("about.teamTitle")}</h2>
          <div className="gold-divider" style={{margin:"16px auto 0"}} />
        </div>
        <div className="team-grid">
          {team.map((member) => (
            <div key={member.name} className="team-card">
              <div className="team-avatar">{member.initial}</div>
              <div className="team-name">{member.name}</div>
              <div className="team-role">{member.role}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-section" style={{background:"var(--cream)",textAlign:"center"}}>
        <span className="section-tag">{t("about.ctaTag")}</span>
        <h2 className="section-title" style={{margin:"0 auto 16px"}}>{t("about.ctaTitle")}</h2>
        <p className="section-subtitle" style={{margin:"0 auto 32px"}}>{t("about.ctaSub")}</p>
        <button className="btn-gold" onClick={() => navigate("/contact")}>{t("about.ctaBtn")}</button>
      </section>
    </>
  );
};

export default AboutPage;
